import { render } from "./ActivityLogsTable.vue?vue&type=template&id=215573be&scoped=true"
import script from "./ActivityLogsTable.vue?vue&type=script&lang=js"
export * from "./ActivityLogsTable.vue?vue&type=script&lang=js"

import "./ActivityLogsTable.vue?vue&type=style&index=0&id=215573be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215573be"]])

export default __exports__